export default __webpack_public_path__ + "static/media/phone.beb06d86.jpg";